import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://vorkyhszdfbzqqzdsull.supabase.co";
const supabaseAnonKey: string = process.env.REACT_APP_SUPABASE_KEY ?? "";
export const supabase = createClient(supabaseUrl, supabaseAnonKey);
